import config from "../../config";
import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Fade, Zoom } from "react-reveal";

const Community = () => {
    const loginDetails = useSelector((state) => state.auth.LoginDetails);



  const navigatetotop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="community pt-0 pb-5 position-relative" >
        <Container>
          <div className="communitytool p-4 ">
          
            <Zoom>
              <Row className="align-items-center  text-center">
                <Col lg={12}>
                  <div className="impressedbox">
                    <div className="mb-3">
                      <h1 className="text-primary">
                        IMPRESSED? Join the INFI Community Today!
                      </h1>
                    </div>
                    <Button
                      variant="outline-custombtn"
                      className="me-2 text-uppercase px-4 py-2 mb-lg-3 mb-md-3 mb-2"
                      style={{ letterSpacing: "1.1px" }}
                      href="https://launchpad.infimultichain.com/"
                      target="_blank"
                    >
                      Take me To Trade/Launchpad!
                    </Button>
                    {Object.keys(loginDetails).length>0?"": <Button
                      variant="custombtn"
                      href={`${config.baseurl}signup`}
                      className="text-uppercase px-4 py-2 mb-lg-3 mb-md-3 mb-2"
                      style={{ letterSpacing: "1.1px" }}
                    >
                      Sign UP Today!
                    </Button>}
                  </div>
                </Col>
              </Row>
            </Zoom>
        
          </div>
        </Container>
      </section>
    </>
  );
};

export default Community;
